<template>
  <div>
    <template v-if="solution">
      <v-toolbar dark color="highlight" flat dense outlined class="sticky-toolbar-breadcrumb">
        <v-toolbar-title>{{$t('solution')}}: {{solution.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu
          transition="scale-transition"
          origin="right top"
          style="z-index: 10"
          class="white"
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn color="white" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="600px">
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_firelog_solutions')}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
        <can I="update" a="solutions">
          <v-btn
            color="secondary"
            small
            depressed
            :disabled="solution.name == ''"
            @click="save"
          >{{$t('save')}}</v-btn>
        </can>
      </v-toolbar>

      <v-container fluid>
        <v-card outlined>
          <v-container fluid class="wrapper">
            <div class="solution_name">
              <v-text-field
                outlined
                dense
                :rules="nameRules"
                :label="$t('name')"
                :counter="50"
                v-model="solution.name"
              ></v-text-field>
            </div>
            <div class="solution_active">
              <v-checkbox v-model="solution.published" color="primary" :label="$t('active')"></v-checkbox>
            </div>
            <div class="solution_image mx-auto text-center">
              <image-uploader
                id="iu1"
                :preview="false"
                capture="environment"
                :debug="1"
                :quality="0.8"
                accept=".jpg, .png"
                :autoRotate="true"
                outputFormat="verbose"
                @input="setSolutionImage"
              >
                <label for="iu1" slot="upload-label">
                  <template v-if="solution.image">
                    <v-img
                      height="145"
                      width="145"
                      aspect-ratio="1"
                      :src="(solution.image == null) ? emptyImage : solution.image"
                    ></v-img>
                    <a class="primary--text">{{$t('changeImage')}}</a>
                  </template>
                  <v-icon size="150" v-else>add_photo_alternate</v-icon>
                </label>
              </image-uploader>
            </div>
          </v-container>
        </v-card>
        <v-row dense>
          <v-col cols="sm" sm="12">
            <v-card outlined flat>
              <v-toolbar class="pl-0" dense flat>
                <v-subheader>{{$t("attachment")}}</v-subheader>
                <v-spacer></v-spacer>
              </v-toolbar>
              <swipe-list :items="solution.productAttachments" item-key="id">
                <template v-slot="{ item}">
                  <v-divider></v-divider>
                  <v-list-item dense :key="item.id">
                    <v-list-item-title style="margin-left: 5px">
                      <a :href="item.link">{{item.name}}</a>
                    </v-list-item-title>
                  </v-list-item>
                </template>
                <template v-if="$can('update','solutions')" v-slot:right="{ item}">
                  <div class="swipeout-action red" title="remove">
                    <areyousure
                      v-on:delete="deleteProductAttachment"
                      :icon="true"
                      color="white"
                      :id="item.id"
                      object="productAttachment"
                    ></areyousure>
                  </div>
                </template>
              </swipe-list>

              <v-form v-if="$can('update','solutions')" v-model="valid2">
                <v-list-item>
                  <label style="cursor: pointer" for="file">
                    <v-icon v-ripple>attach_file</v-icon>
                    {{file != null ? file.name : $t('chooseFile')}}
                  </label>
                  <input
                    @change="changeAttachment"
                    style="display:none"
                    type="file"
                    ref="file"
                    id="file"
                  />
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="!file"
                    small
                    depressed
                    color="secondary"
                    @click="uploadAttachment"
                  >{{$t('add')}}</v-btn>
                </v-list-item>
              </v-form>
            </v-card>
          </v-col>
          <v-col cols="sm" sm="12">
            <v-card outlined :loading="!products" flat>
              <v-toolbar class="pl-0" dense flat>
                <v-subheader>{{$t("products")}}</v-subheader>
                <v-spacer></v-spacer>
              </v-toolbar>
              <swipe-list ref="list" class="card" :items="products" item-key="id">
                <template v-slot="{ item}">
                  <v-divider></v-divider>
                  <v-list-item @dblclick="goToProductDetails(item)" dense :key="item.id">
                    <v-divider></v-divider>
                    <v-list-item-avatar tile size="40" mr-5>
                      <v-img v-if="item.image" :src="item.image"></v-img>
                      <img width="40" v-else src="@/assets/empty.png" />
                    </v-list-item-avatar>
                    <v-list-item-title style="margin-left: 5px">{{item.name}}</v-list-item-title>
                    <v-list-item-action v-if="item.isPIM">
                      <v-icon color="primary">lock</v-icon>
                    </v-list-item-action>
                    <v-list-item-action v-if="!item.isPIM">
                      <v-icon
                        color="primary"
                        small
                        @click.prevent="goToProductDetails(item)"
                      >fa-edit</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
                <template v-if="$can('update','solutions')" v-slot:right="{ item}">
                  <div class="swipeout-action red" title="remove">
                    <areyousure
                      v-on:deleteSolutionXproduct="deleteProduct"
                      :icon="true"
                      color="white"
                      :id="solution.id"
                      :fk="item.id"
                      object="solutionXproduct"
                    ></areyousure>
                  </div>
                </template>
              </swipe-list>
              <v-form v-if="$can('update','solutions')" v-model="valid2">
                <v-list-item>
                  <v-text-field
                    v-model="product"
                    append-outer-icon="mdi-plus"
                    @click:append-outer="add"
                    outlined
                    dense
                    v-bind:label="$t('addProduct')"
                  ></v-text-field>
                </v-list-item>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <savebeforeleave v-on:response="response($event,save)" :dialog="saveDialog"></savebeforeleave>
    </template>
    <v-container fill-height v-else>
      <loading></loading>
    </v-container>
  </div>
</template>

<script>
import uuid from "uuid";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
export default {
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      if (this.$can("update", "solutions")) {
        this.saveDialog = true;
        this.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
  components: {
    SwipeOut,
    SwipeList,
  },
  data() {
    return {
      solution: null,
      products: [],
      nameRules: [
        (v) => !!v || `${this.$t("name")} ${this.$t("required")}`,
        (v) => v.length <= 50 || "",
      ],
      file: null,
      searchtable: null,
      product: "",
      search: null,
      pimProducts: [],
      hasChanges: false,
      selectedSolution: null,
      selectedProduct: null,
      items: [],
      showDelete: false,
      valid: false,
      valid2: false,
      emptyImage: require("@/assets/empty.png"),
      saveDialog: false,
      to: null,
    };
  },
  methods: {
    makeBackButton() {
      this.$store.state.previous = {
        name: "Solutions",
        breadcrumb: this.$t("solutions"),
      };
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("customsolutions"),
          to: { name: "Solutions" },
        },
        {
          name: this.solution.name,
        },
      ];
    },
    goToProductDetails(item) {
      if (!item.isPIM) {
        this.$router.push({
          name: "ProductDetails",
          params: {
            id: item.id,
            solutionId: this.solution.id,
            solutionName: this.solution.name,
          },
        });
      }
    },
    changeAttachment() {
      this.file = this.$refs.file.files[0];
    },
    uploadAttachment() {
      let form = new FormData();
      form.append("attachment", this.file);
      form.append("solutionId", this.solution.id);
      this.$http
        .uploadAttachment(form)
        .then((res) => {
          this.solution.productAttachments.push(res.data);
          this.file = null;
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch((err) => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    warning() {
      if (this.hasChanges) {
        this.saveDialog = true;
      }
    },
    response(answer, callback) {
      if (answer) {
        callback();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params,
      });
    },
    deleteProduct(id) {
      this.products = this.products.filter((x) => x.id != id);
    },
    deleteProductAttachment(id) {
      this.solution.productAttachments = this.solution.productAttachments.filter(
        (x) => x.id != id
      );
    },
    setSolutionImage(output) {
      this.solution.image = output.dataUrl;
      // this.hasChanges = true;
    },
    add() {
      if (this.product && this.valid2) {
        if (typeof this.product === "string") {
          this.$http
            .addProduct(this.solution.id, {
              id: uuid.v4(),
              name: this.product,
            })
            .then((res) => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.products.push(res.data);
            })
            .catch((err) => {
              console.log(err);
              this.$noty.error(this.$t("error"));
            });
          this.product = null;
        } else if (typeof this.product === "object") {
          this.$http
            .addProduct(this.solution.id, {
              id: this.product.id,
              name: this.product.name,
              isPIM: this.product.isPIM,
            })
            .then((res) => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.products.push(res.data);
            })
            .catch((err) => {
              console.log(err);
              this.$noty.error(this.$t("error"));
            });
          this.product = null;
        }
      }
    },
    addSolution(newSolution) {
      this.$http
        .addSolution(newSolution)
        .then((res) => {
          this.items.push(newSolution);
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch((err) => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    save() {
      if (this.solution) {
        this.$http
          .updateSolution(this.solution)
          .then((res) => {
            this.$noty.success('<i class="fas fa-check"></i>');
            this.hasChanges = false;
          })
          .catch((err) => {
            console.log(err);
            this.$noty.error(this.$t("error"));
          });
      }
    },
    getProductById() {
      this.$http
        .getProductById(this.$route.params.id)
        .then((res) => {
          this.solution = res.data;
          this.getProductsBySolutionId();
          this.makeBackButton();
          this.makeBreadcrumb();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProductsBySolutionId() {
      this.$http
        .getProductsBySolutionId(this.solution.id, true)
        .then((res) => {
          this.products = res.data;
          // this.getProductsBySolutionId();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getProductById();
  },
  watch: {
    solution: {
      handler(n, o) {
        if (o != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
#iu1 {
  display: none;
}
.list {
  max-height: 350px;
  overflow-y: auto;
}

.wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-areas:
    "solution_name solution_name solution_name solution_image"
    "solution_active solution_active solution_active solution_image";
  grid-gap: 1rem;
}

.solution_name {
  grid-area: solution_name;
}
.solution_active {
  grid-area: solution_active;
}
.solution_image {
  grid-area: solution_image;
}

@media (max-width: 768px) {
  .wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      "solution_image"
      "solution_name"
      "solution_active";
    grid-gap: 1rem;
  }
}
</style>
<style scoped>
.swipeout-action {
  display: flex;
  align-items: center;
  padding: 0 3rem;
  cursor: pointer;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/solutions/SolutionDetail.vue